import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

export function AuthSignout() {
  const { logout } = useAuth0();

  useEffect(() => {
    logout();
  }, []);

  return null;
}
